import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { TokenStorageService } from '../_services/token-storage.service';
import { UserService } from '../_services/user.service';
import { NotificationI18nService } from '../core/util/notification-i18n.service';
import { RaizComponent } from '../raiz/raiz.component';

@Component({
  selector: 'app-clave',
  templateUrl: './clave.component.html',
  styleUrls: ['./clave.component.css']
})
export class ClaveComponent extends UnsubscribeOnDestroy implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private usuarioService: UserService,
    private notificationI18n: NotificationI18nService,
    private raiz: RaizComponent
  ) {
    super();
  }

  ngOnInit(): void {
    this.tokenStorage.saveToken(this.route.snapshot.paramMap.get("id"));
    this.usuarioService.getCurrentUserFromServer()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {

          if (data.Usuario != null) {
            this.tokenStorage.setUser(data.Usuario, data.usuarioRepresenta);
            if (data.Usuario.email) {
              this.raiz.reloadHeader = !this.raiz.reloadHeader;
              var nextUrl = localStorage.getItem('nextUrl');
              if (nextUrl != null) {
                localStorage.removeItem('nextUrl');
                this.router.navigateByUrl(`/${nextUrl}`);
              }
              else {
                this.router.navigate(['inicio']);
              }

            } else {
              this.raiz.reloadHeader = !this.raiz.reloadHeader;
              this.router.navigateByUrl('/perfil?action=20');
            }
          }
        },
        error: (error) => {
          if (error.error.status == 651) {
            this.notificationI18n.errorRedir(
              'COMMON.NOTIFICATION.ERROR',
              'LOGIN.ERROR.USER_DEACTIVATED',
              50000,
              'LOGIN.ERROR.REACTIVATE_LINK',
              '../forgot-password'
            );
            this.logout();
            this.router.navigate(['inicio']);
          }
          else {
            this.notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDO_RECUPERAR_EL_USUARIO');
            this.router.navigate(['inicio']);
          }
        },
      })
  }
  logout(): void {
    this.tokenStorage.signOut();
  }
}
